export default function AboutSection() {
  const stats = [
    { value: '150+', label: 'Projects Delivered' },
    { value: '40%', label: 'Efficiency Uplift' },
    { value: '98%', label: 'Success Rate' },
  ];

  return (
    <section id="about" className="py-24" style={{ background: 'linear-gradient(180deg, #09090f 0%, #0d0d1a 100%)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative overflow-hidden" style={{ borderRadius: '12px', border: '1px solid rgba(201,168,76,0.2)' }}>
              <img
                alt="Éclat-Gen Innovation Workspace"
                className="object-cover w-full h-96 object-top"
                src="https://public.readdy.ai/ai/img_res/1f7dc3a2bdbd6e1e5d0996554844b79d.jpg"
              />
              <div className="absolute inset-0 pointer-events-none" style={{ background: 'linear-gradient(135deg, rgba(9,9,15,0.3) 0%, transparent 60%)' }} />
            </div>
            {/* Floating tag */}
            <div
              className="absolute -bottom-4 -right-4 px-5 py-4 hidden md:block"
              style={{ background: 'rgba(9,9,15,0.95)', backdropFilter: 'blur(20px)', borderRadius: '10px', border: '1px solid rgba(201,168,76,0.3)' }}
            >
              <div className="flex items-center gap-2 mb-1">
                <div className="w-2 h-2 rounded-full animate-pulse" style={{ background: '#c9a84c' }} />
                <span className="text-xs font-semibold tracking-wide" style={{ color: '#c9a84c' }}>Est. 2022</span>
              </div>
              <div className="text-white/90 font-bold text-xl tracking-tight">Éclat-Gen</div>
              <div className="text-xs text-white/40 tracking-wide">Brilliance. Engineered.</div>
            </div>
          </div>

          {/* Content */}
          <div>
            <span className="inline-block text-xs font-semibold tracking-[0.25em] uppercase mb-4" style={{ color: '#c9a84c' }}>
              Our Story
            </span>
            <h2 className="text-4xl font-bold text-white mb-6 leading-tight tracking-tight">
              Pioneers in{' '}
              <span style={{ background: 'linear-gradient(135deg, #c9a84c, #e8c87a)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                Physical AI
              </span>{' '}
              &amp; Biosensor Innovation
            </h2>
            <p className="text-base text-white/55 mb-5 leading-relaxed font-light">
              Éclat-Gen specializes in the convergence of generative AI and advanced materials science, revolutionizing how organizations harness intelligent systems. We deliver strategic research collaboration and consulting services, pioneering cutting-edge sensor technologies for molecular detection and real-time health monitoring.
            </p>
            <p className="text-base text-white/55 mb-10 leading-relaxed font-light">
              Our proprietary &quot;Lab-in-a-Loop&quot; platform leverages semiconducting organic frameworks to accelerate drug discovery and biotechnology breakthroughs. We&apos;ve guided 150+ organizations through complex transformation challenges, reducing operational inefficiencies by an average of 40%.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mb-10">
              {stats.map((s) => (
                <div
                  key={s.label}
                  className="text-center p-4"
                  style={{ background: 'rgba(201,168,76,0.05)', border: '1px solid rgba(201,168,76,0.15)', borderRadius: '8px' }}
                >
                  <div
                    className="text-3xl font-bold mb-1"
                    style={{ background: 'linear-gradient(135deg, #c9a84c, #e8c87a)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}
                  >
                    {s.value}
                  </div>
                  <div className="text-xs text-white/45 tracking-wide">{s.label}</div>
                </div>
              ))}
            </div>

            <a
              href="#team"
              className="inline-flex items-center gap-2 px-7 py-3 text-sm font-semibold whitespace-nowrap cursor-pointer transition-all duration-300 tracking-wide hover:opacity-90"
              style={{ background: 'linear-gradient(135deg, #c9a84c, #e8c87a)', color: '#09090f', borderRadius: '4px' }}
            >
              Meet Our Team <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
